import type { CarePlan } from "@medplum/fhirtypes";
import { CARE_PLAN_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useCarePlanSubscription = createSubscriptionHook<CarePlan>("CarePlan", CARE_PLAN_COLLECTION_NAME);
